import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import buybackEnabled from '@backmarket/nuxt-layer-buyback/app/middleware/buybackEnabled'
import { ROLES } from '@backmarket/nuxt-layer-buyback/app/scopes/order/components/OrderConversation/OrderConversation.constants'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { ROUTES as AUTH_ROUTES } from '~/scopes/auth/route-names'
import { CMS } from '~/scopes/cms/routes-names'

import { ROUTE_NAMES } from './constants'

export default (): RouteRecordRaw[] => {
  const { market } = useMarketplace()
  const { FF_ENABLE_TRADE_IN_PRODUCT_PAGES } = useRuntimeConfig().public

  return [
    {
      path: 'buyback-funnel',
      component: () =>
        import('~/scopes/buyback/components/BuybackErrorBoundary/BuybackErrorBoundaryPage.vue'),
      meta: {
        layout: 'minimal',
        owners: ['bot-squad-circularity-offer-front'],
        middleware: [buybackEnabled],
      },
      children: [
        {
          name: ROUTE_NAMES.DEVICE_ASSESSMENT,
          path: 'device/:slug/:id',
          component: () =>
            import('~/scopes/buyback/pages/DeviceAssessment.vue'),
          meta: {
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
        {
          name: ROUTE_NAMES.OFFER,
          path: 'device/:slug/:id/offer/:listingId',
          component: () => import('~/scopes/buyback/pages/Offer.vue'),
          meta: {
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
        {
          name: ROUTE_NAMES.NO_OFFER,
          path: 'device/:slug/:id/no-offer',
          component: () => import('~/scopes/buyback/pages/NoOffer.vue'),
          meta: {
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
        {
          name: ROUTE_NAMES.BANK,
          path: 'device/:slug/:id/offer/:listingId/bank',
          component: () => import('~/scopes/buyback/pages/Bank.vue'),
          meta: {
            auth: {
              required: true,
              redirection: {
                name: AUTH_ROUTES.AUTH.LOGIN,
                query: { bm_journey: CMS.BUYBACK },
              },
            },
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
        {
          name: ROUTE_NAMES.ADDRESS,
          path: 'device/:slug/:id/offer/:listingId/address',
          component: () => import('~/scopes/buyback/pages/Address.vue'),
          meta: {
            auth: {
              required: true,
              redirection: {
                name: AUTH_ROUTES.AUTH.LOGIN,
                query: { bm_journey: CMS.BUYBACK },
              },
            },
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
        {
          name: ROUTE_NAMES.SHIPPING,
          path: 'device/:slug/:id/offer/:listingId/address/:addressId/shipping',
          component: () => import('~/scopes/buyback/pages/Shipping.vue'),
          meta: {
            auth: {
              required: true,
              redirection: {
                name: AUTH_ROUTES.AUTH.LOGIN,
                query: { bm_journey: CMS.BUYBACK },
              },
            },
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
        {
          name: ROUTE_NAMES.CONFIRMATION,
          path: 'confirmation/:id',
          component: () => import('~/scopes/buyback/pages/Confirmation.vue'),
          meta: {
            auth: {
              required: true,
              redirection: {
                name: AUTH_ROUTES.AUTH.LOGIN,
                query: { bm_journey: CMS.BUYBACK },
              },
            },
            owners: ['bot-squad-circularity-offer-front'],
          },
        },
      ],
    },
    {
      name: ROUTE_NAMES.CONVERSATION,
      path: 'dashboard/sales/:id/conversation',
      component: () =>
        import('@backmarket/nuxt-layer-buyback/app/scopes/order/components/OrderConversation/OrderConversation.vue'),
      meta: {
        auth: {
          required: true,
          redirection: {
            name: AUTH_ROUTES.AUTH.LOGIN,
            query: { bm_journey: CMS.BUYBACK },
          },
        },
        owners: ['bot-squad-circularity-offer-front'],
        layout: 'minimal',
      },
      props: {
        role: ROLES.CUSTOMER,
      },
    },
    {
      name: ROUTE_NAMES.TRADE_IN_PRODUCT,
      path: 'buyback/:category/:slug/:id',
      component: () => import('~/scopes/buyback/pages/ProductPage.vue'),
      meta: {
        owners: ['bot-squad-circularity-offer-front'],
        routeExists: () =>
          FF_ENABLE_TRADE_IN_PRODUCT_PAGES.includes(market.countryCode),
        middleware: [buybackEnabled],
      },
    },
  ]
}
